import { useConfigStore, useUserSettingsStore } from '@/stores';

export interface UseVideoRecall {
  /** Effective switch used to gate rewind: false if the deployment disabled it OR the user did. */
  enabled: boolean;
  /** The per-user preference (independent of the deployment override). */
  userEnabled: boolean;
  /** True when the deployment /config flag forces rewind off for everyone. */
  disabledByConfig: boolean;
  setEnableVideoRecall: (value: boolean) => void;
}

/**
 * Resolves whether HLS rewind (DVR) is available. The deployment `/config` flag
 * (`video_recall_disabled`) is an override that wins over the per-user preference:
 * effective = NOT disabledByConfig AND userEnabled.
 */
export const useVideoRecall = (): UseVideoRecall => {
  const disabledByConfig = useConfigStore(state => state.videoRecallDisabled) ?? false;
  const userEnabled = useUserSettingsStore(state => state.enableVideoRecall);
  const setEnableVideoRecall = useUserSettingsStore(state => state.setEnableVideoRecall);

  return {
    enabled: !disabledByConfig && userEnabled,
    userEnabled,
    disabledByConfig,
    setEnableVideoRecall,
  };
};
